
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/photo-books",
      function () {
        return require("private-next-pages/photo-books.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/photo-books"])
      });
    }
  